import React from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { Container } from 'reactstrap';
import { useQuery } from '@apollo/client';
import { GET_JOINTS_BY_CERTIFICATE_ID } from '../../../graph-queries/tar/joint';
import JointViewForm from '../../organisms/JointForm/JointViewForm';
import { TJoint } from '../../../lib/types';
import classes from './JointsView.module.scss';

const JointsView: React.FC = () => {
  const { certificateId } = useParams<{ certificateId: string }>();
  const [searchParams] = useSearchParams();
  const type = searchParams.get('type') || '';

  const { data, loading } = useQuery(GET_JOINTS_BY_CERTIFICATE_ID, {
    variables: { certificateId: Number(certificateId) },
    skip: !certificateId,
  });

  const joints = (data?.jointsByCertificateId as unknown as TJoint[]) || [];

  return (
    <Container fluid className={`p-0 ${classes.container}`}>
      <JointViewForm joints={joints} isLoading={loading} type={type} />
    </Container>
  );
};

export default JointsView;
